import React, { useRef } from 'react'
import noop from 'lodash/noop'

import Image from 'src/comps/Image'
import { useLazyLoading } from 'src/hooks/useLazyLoading'

import { PhotoBase } from './styles'
import { IMAGE_LOADING } from '../Image/constants'

interface Props {
  alt: string
  aspectRatio?: string
  className?: string
  id: string
  onPhotoClick?: (index?: number) => void
  photo: {
    loading?: (typeof IMAGE_LOADING)[number]
    width?: number
    height?: number
    src: string
    srcSet?: string[]
    sizes?: string[]
    preload?: boolean
  }
}

const PhotoLazy = ({
  alt,
  aspectRatio,
  className = 'photo-lazy',
  id,
  onPhotoClick = noop,
  photo,
}: Props) => {
  const ref = useRef(null)
  const inViewport = useLazyLoading(ref)

  return (
    <PhotoBase ref={ref} id={id} className={className} data-testid="photo-lazy">
      {(inViewport || photo.loading === 'eager') && (
        <Image {...photo} alt={alt} aspectRatio={aspectRatio} onClick={() => onPhotoClick()} />
      )}
    </PhotoBase>
  )
}

export default PhotoLazy
